import { render } from "./UnpublishAnnouncementDialog.vue?vue&type=template&id=ec4ea12c"
import script from "./UnpublishAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./UnpublishAnnouncementDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__